import styles from './VModalCatalog.module.css'
import buttons from './../../Buttons.module.css'

import { useEffect, useRef, useState, useMemo } from 'react';
// Images
import icon_error from './../../../assets/img/icons/error.svg'
// Modal
import PopupAppearLayout from "../Layouts/PopupAppearLayout";
import Modal_1 from '../Modal_1';
import VNewsModal from '../../../pages/news/VNewsModal';
import { useModalWindow } from 'react-modal-global';
// RTK Query
import { useGetCatalogMutation } from "../../../../../features/catalog/catalogApiSlice";
// Sort
import { createNestedObject } from './SortArray';
// use Media
import { useMedia } from '../../../../../customHooks/useMedia';
// useScrollBlock
import useScrollBlock from '../../../../../customHooks/useScrollBlock';
// functions
import { formatPrice } from '../../../../../customHooks/functions';
// Categories
import PartHeader from './PartHeader';
import PartCategory from './PartCategory';
import PartCatalog from './PartCatalog';
import PartCart from './PartCart';
import PartOrderDetails from './PartOrderDetails';
import PartSalesDisabled from './PartSalesDisabled';
// Redux
import { useSelector, useDispatch } from 'react-redux';
import { setDefaultThemeColor, setNewThemeColor } from '../../../../../features/helmet/helmetSlice';
import LoaderInline from '../../../../other/Loaders/LoaderInline';
// Данные новостей (единый источник)
import { getNewsById, PRICE_NEWS_ID } from '../../../../../data/news';

const ModalCatalog = ({defaultCartOpen, defaultOrderDetailsOpen, catalogTab}) => {

    const [category, setCategory] = useState(catalogTab ? catalogTab : '18.9л');
    const [salesDisabledInfo, setSalesDisabledInfo] = useState(null);

    const modal = useModalWindow();
    const [blockScroll, allowScroll] = useScrollBlock();
    const dispatch = useDispatch();
    const changeThemeColor = (color) => dispatch(setNewThemeColor(color));

    const closeModal = () => {
        allowScroll(); // Разблокируем скролл перед закрытием
        modal.close();
    };

    const openPriceNews = () => {
        changeThemeColor({color: '#5c5d5e'});
        blockScroll();
        Modal_1.open(VNewsModal, {data: getNewsById(PRICE_NEWS_ID)});
    };

    const anchor = useRef();

    function scrollToTop(){
        anchor.current?.scrollIntoView({ block:'nearest' });
    }
    
    // ORDER DETAILS
    const [orderDetailsShown, setOrderDetailsShown] = useState(defaultOrderDetailsOpen)
    useEffect(() => {
      if(!modal.closed){
        setOrderDetailsShown(defaultOrderDetailsOpen);
      }
    }, [modal.closed]);
    // Cart
    const [cartShown, setCartShown] = useState(defaultCartOpen)
    useEffect(() => {
      if(!modal.closed){
        setCartShown(defaultCartOpen);
      }
    }, [modal.closed]);

    const hideCartHideOrderDetails = () =>  {
                                              setCartShown(false)
                                              setOrderDetailsShown(false)
                                              scrollToTop()
                                            }
    const showCartHideOrderDetails = () =>  {
                                              setCartShown(true)
                                              setOrderDetailsShown(false)
                                              scrollToTop()
                                            }
    const hideCartShowOrderDetails = () =>  {
                                              setCartShown(false)
                                              setOrderDetailsShown(true)
                                              scrollToTop()
                                            }

    // const { data: dbUnsortedData, isLoading, isSuccess, isError, error } = useGetCatalogQuery()
    const [getCatalog, {
        data: dbUnsortedData,
        isLoading, 
        isSuccess, 
        isError, 
        error
    }] = useGetCatalogMutation()

    useEffect( () => {
      if(!modal.closed){
        getCatalog()
      }
    },[modal.closed])

    // Мемоизируем обработку данных, чтобы не вызывать createNestedObject дважды
    const dbSortedData = useMemo(() => {
        if (isSuccess && dbUnsortedData) {
            // Проверяем статус продаж
            if (dbUnsortedData.salesEnabled === false && dbUnsortedData.message) {
                setSalesDisabledInfo(dbUnsortedData.message);
                // Закрываем каталог немедленно
                closeModal();
            }
            
            // Обрабатываем каталог (может быть пустым если продажи отключены)
            if (dbUnsortedData.catalog && dbUnsortedData.catalog.length > 0) {
                return createNestedObject(dbUnsortedData.catalog);
            } else if (Array.isArray(dbUnsortedData)) {
                // Если пришел массив напрямую (старый формат)
                return createNestedObject(dbUnsortedData);
            }
        }
        return null;
    }, [isSuccess, dbUnsortedData]);

    // Устанавливаем категорию "Акции" если она есть в данных
    useEffect(() => {
        if (dbSortedData && dbSortedData["Акции"]) {
            setCategory("Акции");
        } else if (dbSortedData && !catalogTab) {
            // Если нет Акций и не передан catalogTab, оставляем '18.9л'
            setCategory('18.9л');
        }
    }, [dbSortedData, catalogTab]);
  
    const isLarge850 = useMedia('(min-width: 850px)');

    // Redux
    const totalPriceShoppingCart = useSelector(state => state.cart.totalPrice);

    // Page content
    let content
    if(isError){
      content = <div className={styles.loading_block}>
                    <p className={styles.loading_title}>Ошибка</p>
                    <img className={styles.loading_error} src={icon_error} alt='error icon' />
                    <p className={styles.loading_text}>Не удалось загрузить каталог. Попробуйте еще раз</p>
                    <button className={`${buttons.btn_solid_blue} ${styles.loading_btnRefresh}`} onClick={() => getCatalog()}>Обновить</button>
                </div>
    }
    if(isLoading){
      content = <div className={styles.loading_block}>
                  <p className={styles.loading_title}>Загрузка...</p>
                  <LoaderInline sizeInPx="60px" borderWidth="10px"/>
                  <p className={styles.loading_text}>Пожалуйста подождите...</p>
                </div>
    }

    if(isSuccess){
        // process data from server
        // dbSortedData уже вычислен через useMemo выше
        
        // Если продажи отключены и нет каталога - показываем только сообщение
        if (salesDisabledInfo && !dbSortedData) {
            content = <div className={styles.loading_block}>
                        <p className={styles.loading_title}>Каталог недоступен</p>
                        <p className={styles.loading_text}>В настоящее время продажи временно приостановлены</p>
                      </div>
        } else if (dbSortedData) {
            // Нормальный рендер каталога только если есть данные
            content = <>
                    {/* HEADER */}
                    <div ref={anchor}></div>
                    <PartHeader 
                        cartShown={cartShown} 
                        orderDetailsShown={orderDetailsShown}
                        isLarge850={isLarge850}
                        
                        showCartHideOrderDetails={showCartHideOrderDetails}
                        hideCartHideOrderDetails={hideCartHideOrderDetails}
                    />
                    {/* <div className={styles.priceNotice}>
                        <span className={styles.priceNoticeText}>Повышение цен с 1 янв. 2026 г.</span>
                        <button className={styles.btnPriceNews} onClick={openPriceNews}>Инфо</button>
                    </div> */}

                    <div className={`${styles.catalog__container} 
                                      ${!isLarge850 && cartShown && "cartShown"}
                                  `}>
                        
                                      {/* order details */}
                                      {
                                        orderDetailsShown
                                            ? <PartOrderDetails setOrderDetailsShown={setOrderDetailsShown} />
                                            : null
                                      }

                                      {/* catalog */}
                                      {
                                        ((!cartShown && !orderDetailsShown) || (isLarge850 && !orderDetailsShown))
                                            ? <div className={styles.left_middle_col_block}> 
                                                  {/* CATEGORIES */}
                                                  <div className={styles.catalog__left}>
                                                      <PartCategory 
                                                            dbSortedData={dbSortedData} 
                                                            category={category} 
                                                            setCategory={setCategory} 
                                                      />
                                                  </div>
                                                  {/* ITEMS */}
                                                  <div className={styles.catalog__middle}>
                                                      <PartCatalog 
                                                          dbUnsortedData={dbUnsortedData?.catalog} 
                                                          dbSortedData={dbSortedData} 
                                                          category={category} 
                                                      />
                                                  </div>
                                              </div>
                                            : null
                                      }
                                      
                                      {/* cart */}
                                      {
                                        ((cartShown && !orderDetailsShown) || isLarge850)
                                            ? <div className={styles.catalog__right}>
                                                <PartCart 
                                                      orderDetailsShown={orderDetailsShown} 
                                                      setOrderDetailsShown={setOrderDetailsShown} 
                                                      isLarge850={isLarge850}
                                                />
                                              </div> 
                                            : null
                                      }
                                      {/* floating buttons */}
                                      {
                                        isLarge850
                                          ? null
                                          : <div className={styles.open_orderDetails_start}>
                                                {/* order details */}
                                                {
                                                  // no floatintg buttons on the screen
                                                }
                                                {/* catalog */}
                                                {
                                                  !cartShown && !orderDetailsShown && totalPriceShoppingCart
                                                      ? <button 
                                                          className={"selectDisable " + styles.item_btn_blue}
                                                          onClick={showCartHideOrderDetails}
                                                        >
                                                            Корзина ( {formatPrice(totalPriceShoppingCart, ' ')} тг )
                                                        </button>
                                                      : null
                                                }
                                                {/* cart */}
                                                {
                                                  cartShown && !orderDetailsShown && totalPriceShoppingCart
                                                      ? <button 
                                                            className={"selectDisable " + styles.item_btn_blue}
                                                            onClick={hideCartShowOrderDetails}
                                                        >
                                                            Оформить {formatPrice(totalPriceShoppingCart, ' ')} тг
                                                        </button>
                                                      : null
                                                  
                                                }
                                            </div>
                                        }
                        
                       
                        
                    </div>
                  </>
        } else {
            // Если нет данных вообще
            content = <div className={styles.loading_block}>
                        <p className={styles.loading_title}>Нет данных</p>
                        <p className={styles.loading_text}>Каталог пуст</p>
                      </div>
        }
      }

      return(
        <>
            <PopupAppearLayout classNameLayout={styles.popup__layout}>
                {content}
            </PopupAppearLayout>
            
            {/* Показываем информационное окно поверх всего */}
            {salesDisabledInfo && (
                <PartSalesDisabled 
                    message={salesDisabledInfo} 
                    onClose={() => {
                        allowScroll(); // Разблокируем скролл
                        setSalesDisabledInfo(null);
                    }}
                />
            )}
        </>
      )
}

export default ModalCatalog;
